const UserFlagsMapping = Object.freeze({
  'None': 0,
  'Auditor': 1,
  'AccountAdmin': 2,
  'SuperUser': 4,
  'Analytics': 8
});

export default UserFlagsMapping;